(function () {
    var BLOCKED_HANDLES = ['joyero-de-viaje']; // añade más si quieres

    function extractHandleFromHref(href) {
      try {
        var u = new URL(href, location.origin);
        var m = u.pathname.match(/^\/products\/([^\/]+)/i);
        return m ? m[1] : null;
      } catch (e) {
        return null;
      }
    }

    function disableGiftLinks(root) {
      (root || document).querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        if (a.dataset.giftDisabled === '1') return;
        var handle = extractHandleFromHref(a.getAttribute('href') || '');
        if (handle && BLOCKED_HANDLES.indexOf(handle) !== -1) {
          a.addEventListener('click', function (e) { e.preventDefault(); }, { capture: true });
          a.setAttribute('aria-disabled', 'true');
          a.setAttribute('tabindex', '-1');
          a.style.pointerEvents = 'none';
          a.style.cursor = 'not-allowed';
          if (!a.title) a.title = 'Producto promocional no clicable';
          a.dataset.giftDisabled = '1';
        }
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      disableGiftLinks(document);
      // Observa cambios (carrito/drawer AJAX)
      var mo = new MutationObserver(function (muts) {
        disableGiftLinks(document);
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    });
  })();